import { app } from '../../../../bootstrap/core';
import { sidebarSectionComponent } from './sidebarSection.component';

app.component('sidebarSection', sidebarSectionComponent);
